/**
 * 平台检测工具函数
 */

/**
 * 检测是否运行在 iOS Standalone Mode (添加到主屏幕后)
 *
 * @returns true 表示运行在 Standalone Mode
 */
export function isIOSStandaloneMode(): boolean {
  // 检测是否为 iOS 设备
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  // 检测是否在 Standalone Mode (通过 window.navigator.standalone 或 display-mode)
  const isStandalone =
    (window.navigator as any).standalone === true || // iOS Safari
    window.matchMedia("(display-mode: standalone)").matches; // 标准方式

  return isIOS && isStandalone;
}

/**
 * 检测是否为 iOS 设备
 */
export function isIOS(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

/**
 * 检测是否为 iPad
 */
export function isIPad(): boolean {
  return /iPad/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

/**
 * 获取当前运行模式信息 (用于调试)
 */
export function getDeviceInfo() {
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    isIOS: isIOS(),
    isIPad: isIPad(),
    isStandalone: isIOSStandaloneMode(),
    standalone: (window.navigator as any).standalone,
    displayMode: window.matchMedia("(display-mode: standalone)").matches ? "standalone" : "browser",
    visualViewport: {
      width: window.visualViewport?.width,
      height: window.visualViewport?.height,
      scale: window.visualViewport?.scale,
    },
    window: {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      outerWidth: window.outerWidth,
      outerHeight: window.outerHeight,
    },
  };
}
